(function () {
  const GIFT_VARIANT_ID = 49997120995650;
  const ELIGIBLE_PRODUCT_TYPE = 'press on nail';

  // 当前规则：买 3 副 press-on nails，送 1 个 Caja Sorpresa
  const GIFT_THRESHOLD = 3;

  // 保留你原来的逻辑：最多送 2 个
  // 也就是买 3 送 1，买 6 送 2，最多 2 个
  const MAX_GIFT_QTY = 2;

  let isRunning = false;
  let debounceTimer = null;
  let lastCartSignature = '';

  async function getCart() {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    });

    if (!response.ok) throw new Error('Failed to fetch cart');
    return response.json();
  }

  function getCartSignature(cart) {
    return cart.items
      .map(function (item) {
        return item.variant_id + ':' + item.quantity;
      })
      .join('|');
  }

  function isGiftItem(item) {
    return Number(item.variant_id) === Number(GIFT_VARIANT_ID);
  }

  function isEligibleItem(item) {
    const variantId = Number(item.variant_id);
    const productType = String(item.product_type || '').toLowerCase().trim();
    const handle = String(item.handle || '').toLowerCase().trim();
    const title = String(item.product_title || item.title || '').toLowerCase().trim();

    // 不计算赠品本身
    if (variantId === Number(GIFT_VARIANT_ID)) return false;

    // 不计算 Caja Sorpresa / Surprise Box
    if (handle.includes('caja-sorpresa')) return false;
    if (handle.includes('surprise-box')) return false;
    if (title.includes('caja sorpresa')) return false;
    if (title.includes('surprise box')) return false;

    // 不计算 bundle 产品
    if (handle.includes('bundle')) return false;
    if (title.includes('bundle')) return false;

    // 只计算正常 press-on nail 产品
    return productType === ELIGIBLE_PRODUCT_TYPE;
  }

  function getEligibleQty(cart) {
    return cart.items.reduce(function (total, item) {
      if (!isEligibleItem(item)) return total;
      return total + Number(item.quantity || 0);
    }, 0);
  }

  function getGiftLines(cart) {
    return cart.items.filter(function (item) {
      return Number(item.variant_id) === Number(GIFT_VARIANT_ID);
    });
  }

  function getCurrentGiftQty(cart) {
    return getGiftLines(cart).reduce(function (total, item) {
      return total + Number(item.quantity || 0);
    }, 0);
  }

  function getDesiredGiftQty(eligibleQty) {
    const calculatedQty = Math.floor(eligibleQty / GIFT_THRESHOLD);
    return Math.min(calculatedQty, MAX_GIFT_QTY);
  }

  async function addGift(qty) {
    if (qty <= 0) return false;

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: GIFT_VARIANT_ID,
        quantity: qty,
        properties: {
          _auto_gift: 'true',
          _gift_rule: 'buy_3_get_1_max_2',
        },
      }),
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error('Gift add failed: ' + text);
    }

    return true;
  }

  async function changeGift(lineKey, qty) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: lineKey,
        quantity: qty,
      }),
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error('Gift change failed: ' + text);
    }

    return true;
  }

  async function removeAllGiftLines(giftLines) {
    for (const giftLine of giftLines) {
      await changeGift(giftLine.key, 0);
    }
  }

  async function refreshCartDrawer() {
    const currentCartItemsComponent = document.querySelector('cart-items-component[data-section-id]');
    const sectionId = currentCartItemsComponent?.dataset?.sectionId;

    if (!currentCartItemsComponent || !sectionId) {
      return false;
    }

    const sectionUrl = new URL(window.location.href);
    sectionUrl.searchParams.set('sections', sectionId);
    sectionUrl.searchParams.set('_', Date.now().toString());

    const response = await fetch(sectionUrl.toString(), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    });

    if (!response.ok) return false;

    const sections = await response.json();
    const html = sections[sectionId];

    if (!html) return false;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newCartItemsComponent = doc.querySelector('cart-items-component[data-section-id]');
    if (!newCartItemsComponent) return false;

    currentCartItemsComponent.innerHTML = newCartItemsComponent.innerHTML;

    return true;
  }

  async function refreshCartCount() {
    const currentCartBubble = document.querySelector('.cart-bubble');
    if (!currentCartBubble) return;

    try {
      const cart = await getCart();
      const bubbleText = currentCartBubble.querySelector('.cart-bubble__text');

      if (bubbleText) {
        bubbleText.textContent = cart.item_count;
      }
    } catch (error) {
      // silent
    }
  }

  async function afterGiftChanged() {
    const refreshed = await refreshCartDrawer();
    await refreshCartCount();

    if (!refreshed) {
      window.location.reload();
    }
  }

  async function syncGift() {
    if (isRunning) return;

    isRunning = true;

    try {
      const cart = await getCart();

      const eligibleQty = getEligibleQty(cart);
      const desiredGiftQty = getDesiredGiftQty(eligibleQty);

      const giftLines = getGiftLines(cart);
      const currentGiftQty = getCurrentGiftQty(cart);

      // 如果赠品数量正确，并且只有一条赠品 line，就不动
      if (desiredGiftQty === currentGiftQty && giftLines.length <= 1) {
        return;
      }

      // 为了避免旧规则 properties 导致重复 line，先清掉所有 Caja Sorpresa，再按新规则重新加
      if (giftLines.length > 0) {
        await removeAllGiftLines(giftLines);
      }

      if (desiredGiftQty > 0) {
        await addGift(desiredGiftQty);
      }

      await afterGiftChanged();
    } catch (error) {
      console.warn('[Auto Gift] Sync failed:', error);
    } finally {
      isRunning = false;
    }
  }

  function scheduleSync(delay) {
    window.clearTimeout(debounceTimer);

    debounceTimer = window.setTimeout(function () {
      syncGift();
    }, delay || 700);
  }

  function startAutoGift() {
    scheduleSync(800);

    document.addEventListener(
      'click',
      function () {
        scheduleSync(900);
      },
      true
    );

    document.addEventListener(
      'change',
      function () {
        scheduleSync(900);
      },
      true
    );

    document.addEventListener('cart:updated', function () {
      scheduleSync(500);
    });

    document.addEventListener('cart:change', function () {
      scheduleSync(500);
    });

    document.addEventListener('cart:refresh', function () {
      scheduleSync(500);
    });

    setInterval(async function () {
      try {
        const cart = await getCart();
        const signature = getCartSignature(cart);

        if (signature !== lastCartSignature) {
          lastCartSignature = signature;
          await syncGift();
        }
      } catch (error) {
        // silent
      }
    }, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startAutoGift);
  } else {
    startAutoGift();
  }

  window.KnockKnockAutoGiftSync = syncGift;
})();